import React, {memo} from 'react';
import {AvatarWrapper, ImageWrapper} from './styled';

const Avatar = memo(({customStyle}) => {
  return (
    <AvatarWrapper style={customStyle}>
      <ImageWrapper src={`${process.env.PUBLIC_URL}/lazylogo.svg`} />
      LZ Studio
    </AvatarWrapper>
  );
});

export default Avatar;
